import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Tooltip,
  Divider,
} from '@mui/material';
import PaletteIcon from '@mui/icons-material/Palette';
import CheckIcon from '@mui/icons-material/Check';
import { useAppTheme } from '../../context/AppThemeContext';
import { THEME_PRESETS } from '../../theme/themePresets';
import { toast } from 'react-toastify';

const ThemeSwitcher = ({ iconSx = {} }) => {
  const { themeId, setThemeId } = useAppTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleSelect = (id) => {
    if (id === themeId) {
      setAnchorEl(null);
      return;
    }
    const preset = THEME_PRESETS.find((p) => p.id === id);
    setThemeId(id);
    setAnchorEl(null);
    if (preset) {
      toast.success(`Theme set to ${preset.name}`);
    }
  };

  return (
    <>
      <Tooltip title="Color theme">
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          aria-label="Change color theme"
          sx={{
            color: 'primary.main',
            '&:hover': {
              backgroundColor: (theme) => theme.palette.action.hover,
            },
            ...iconSx,
          }}
        >
          <PaletteIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: { width: 260, maxHeight: 420, borderRadius: 2, mt: 1 },
        }}
      >
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'primary.main' }}>
            Dashboard color theme
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Saved on this device
          </Typography>
        </Box>
        <Divider />
        {THEME_PRESETS.map((preset) => {
          const selected = preset.id === themeId;
          return (
            <MenuItem key={preset.id} onClick={() => handleSelect(preset.id)} selected={selected}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <Box
                  sx={{
                    width: 22,
                    height: 22,
                    borderRadius: '50%',
                    background: preset.gradient,
                    border: '2px solid',
                    borderColor: selected ? 'primary.main' : 'grey.300',
                    boxShadow: selected ? 2 : 0,
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={preset.name}
                primaryTypographyProps={{ variant: 'body2', fontWeight: selected ? 600 : 400 }}
              />
              {selected && (
                <CheckIcon fontSize="small" sx={{ color: 'primary.main', ml: 1 }} />
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default ThemeSwitcher;
